<template>
  <div class="page-container">
    <top/>
    <router-view />
    <bottom v-if="showBottom()"/>
  </div>
</template>

<script>
  import top from './head';
  import bottom from './foot';
  export default {
    name: 'foot',
    data() {
      return {}
    },
    components: {
      top,
      bottom
    },
    methods: {
      showBottom() {
        console.log(this.$route.name)
        if(this.$route.name === 'questionBlank') {
          return false;
        }else {
          return true;
        }        
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/layout/index.vue